import Button from "../UI/Button";
import { SIGNATURE_PRICE } from "../../models/signatureElectronique";
import { currencyFormatter } from "../../api/Functions";
import { handleAPIError } from "../../utils/index.jsx";
import useProperties from "../../hooks/use-properties";
import { useState } from "react";
import Card from "../UI/Card";
import Callout from "../UI/Callout";
import FileDownloadLink from "../UI/FileDownloadLink";
import DocumentDownloadLink from "../UI/DocumentDownloadLink";
import DocumentThumbnail from "../UI/DocumentThumbnail";
import Text from "../UI/Text";
import SignatairesCard from "./SignatairesCard";
import useAccount from "../../hooks/use-account";
import useSignatureAnnexes from "../../hooks/use-signature-annexes";
import styles from "./ElectronicSigning.module.css";
import BuyCredits from "../Stripe/BuyCredits";
import useProfileBailleurs from "../../hooks/use-profile-bailleurs";

export default function ElectronicSigning({
  file,
  onSendToElectronicSigning,
  propertyId,
  tenantProfiles,
  caution,
  showTitle = true,
}) {
  const { account, refresh: refreshAccount } = useAccount();
  const { profileBailleurs } = useProfileBailleurs();
  const { properties } = useProperties();
  const { annexes } = useSignatureAnnexes(file?.id);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  if (!account) return null;

  const property = properties.find((property) => property.id === propertyId);
  if (!properties) return null;
  const profileNom = profileBailleurs.find(
    (profileNom) => profileNom.id === property?.id_profile_nom_owner,
  );
  if (!profileNom) return null;

  return (
    <div>
      {showTitle && <h2 className={"text-center"}>Signature électronique</h2>}
      <BuyCredits account={account} refreshAccount={refreshAccount} />
      <div className={styles.grid}>
        <SignatairesCard profiles={profileNom.profiles} bailleur />
        <SignatairesCard profiles={tenantProfiles} caution={caution} />
      </div>
      {file && (
        <div>
          <p className={"primaryText primaryBlue marginT20 marginB10"}>
            Document à signer :
          </p>
          <FileDownloadLink file={file} />
        </div>
      )}
      {annexes.length > 0 && (
        <div>
          <Text color="primary" weight="medium" className={"marginT20"}>
            Documents joints en annexe :
          </Text>
          <div className={styles.annexes}>
            {annexes.map((annexe) => (
              <Card key={annexe.id} padding="xs" className={styles.annexeRow}>
                <DocumentDownloadLink
                  documentId={annexe.id}
                  file={annexe}
                  className={styles.annexeThumb}
                >
                  <DocumentThumbnail documentId={annexe.id} file={annexe} />
                </DocumentDownloadLink>
                <Text as="span" weight="bold">
                  {annexe.filename ?? "Document"}
                </Text>
              </Card>
            ))}
          </div>
        </div>
      )}
      <p className={"text-center secondaryText marginB10 marginT20"}>
        La signature électronique sera facturée{" "}
        {currencyFormatter(SIGNATURE_PRICE / 100)} TTC sur vos crédits
        disponibles.
      </p>
      {file && (
        <div className={"text-right"}>
          <Button
            type={"button"}
            disabled={account.credits < SIGNATURE_PRICE || isLoading}
            isLoading={isLoading}
            onClick={async () => {
              try {
                setIsLoading(true);
                await onSendToElectronicSigning();
                setError("");
              } catch (error) {
                setError(handleAPIError(error));
              }
              setIsLoading(false);
            }}
          >
            Envoyer pour signature électronique
          </Button>
          <Callout variant="danger">{error}</Callout>
        </div>
      )}
    </div>
  );
}
